// @ts-nocheck
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUser } from "../auth/auth";
import { getAdminLogs } from "../api/admin";
import { useToast } from "../components/ToastProvider";
import "../styles/AdminReports.css";
import "../styles/AdminLogs.css";

export default function AdminLogs() {
  const navigate = useNavigate();
  const user = getUser();
  const { showToast } = useToast();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionFilter, setActionFilter] = useState("all");
  const [query, setQuery] = useState("");

  const fetchLogs = useCallback(async () => {
    try {
      const data = await getAdminLogs();
      setLogs(data || []);
    } catch (error) {
      if (error?.message?.toLowerCase?.().includes("forbidden")) {
        showToast("Unauthorized access", "error");
        navigate("/home");
        return;
      }
      showToast("Failed to load moderation logs", "error");
    } finally {
      setLoading(false);
    }
  }, [navigate, showToast]);

  useEffect(() => {
    if (!user || user.role !== "admin") {
      showToast("Unauthorized access", "error");
      navigate("/home");
      return;
    }

    fetchLogs();
  }, [user, navigate, fetchLogs, showToast]);

  const filteredLogs = logs.filter((log) => {
    if (actionFilter !== "all" && log.action !== actionFilter) {
      return false;
    }

    if (!query.trim()) return true;

    const haystack = [log.adminId, log.action, log.targetUserId || log.targetUser, log.reason]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    return haystack.includes(query.trim().toLowerCase());
  });

  const uniqueActions = Array.from(new Set(logs.map((log) => log.action).filter(Boolean)));

  if (loading) {
    return (
      <div className="admin-logs-page">
        <div className="loading">Loading moderation logs...</div>
      </div>
    );
  }

  return (
    <div className="admin-logs-page">
      <header className="admin-header">
        <button className="back-btn" onClick={() => navigate("/home")}>←</button>
        <div>
          <h1>Moderation Logs</h1>
          <p>Track admin actions and automated moderation events</p>
        </div>
      </header>

      <div className="admin-logs-toolbar">
        <select value={actionFilter} onChange={(event) => setActionFilter(event.target.value)}>
          <option value="all">All actions</option>
          {uniqueActions.map((action) => (
            <option key={action} value={action}>{action}</option>
          ))}
        </select>
        <input
          type="search"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder="Search admin, target user, reason..."
        />
        <button className="refresh-btn" onClick={fetchLogs}>Refresh</button>
      </div>

      <div className="admin-logs-table">
        <div className="admin-logs-table-head">
          <div>When</div>
          <div>Actor</div>
          <div>Action</div>
          <div>Target</div>
          <div>Reason</div>
        </div>
        {filteredLogs.length === 0 ? (
          <div className="admin-logs-empty">No moderation logs found.</div>
        ) : (
          filteredLogs.map((log) => (
            <div className="admin-logs-row" key={log.id}>
              <div>{new Date(log.timestamp || log.createdAt).toLocaleString()}</div>
              <div>{log.adminId || "system"}</div>
              <div><span className="action-pill">{log.action}</span></div>
              <div>{log.targetUserId || log.targetUser || "—"}</div>
              <div>{log.reason || "—"}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
